<template>
  <div class="notepad" :class="{open: isOpen}">
    <div class="controls">
      <button @click="$emit('close')">
        <i class="material-icons" v-if="isOpen">close</i>
      </button>
    </div>

    <h2 class="title">Personal Notepad</h2>

    <div class="notes" :class="{orderable: orderMode}">
      <draggable
        class="list-group"
        tag="ul"
        handle=".handle"
        v-model="notes"
        v-bind="dragOptions"
        @start="drag = true"
        @end="drag = false"
      >
        <transition-group name="note">
          <li v-for="(note, index) in notes" :key="note.id">
            <transition name="fade">
              <span class="handle" v-if="orderMode"><i class="material-icons">drag_handle</i></span>
            </transition>
            <div>
              <input type="text" 
                ref="title"
                v-model="notes[index].title"
                @change="setNotesDebounce"
                :disabled="orderMode">
              <textarea 
                ref="note"
                v-model="notes[index].note"
                @change="setNotesDebounce"
                :disabled="orderMode"></textarea>
            </div>
            <button @click="removeNote(note)"><i class="material-icons">delete</i></button>
          </li>
        </transition-group>
      </draggable>
    </div>
    <div class="buttons">
      <button @click="orderMode = true" v-if="!orderMode" class="add-button btn light inverted"><i class="material-icons">edit</i> <span>Change order</span></button>
      <button @click="orderMode = false" v-else class="add-button btn light inverted"><i class="material-icons">done</i> <span>Confirm order</span></button>
      <button @click="addNote" class="add-button btn light inverted"><i class="material-icons">note_add</i> <span>Add</span></button>
    </div>
    
  </div>
</template>

<script>
var _ = require('lodash');
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
import draggable from "vuedraggable";
export default {
  name: "Notepad",
  mixins: [scenarioMixin],
  props: {
    openDrawer: {
      type: String,
    },
  },
  components: {
    draggable
  },
  data () {
    return {
      orderMode: false
    }
  },
  created () {
    this.$store.dispatch('notepadModule/loadNotes')
  },
  computed: {
    isOpen () {
      return (this.openDrawer === "notepad" ? true : false)
    },
    notes: {
      get () {
        return this.$store.getters["notepadModule/getNotes"]
      },
      set (value) {
        this.$store.dispatch('notepadModule/setNotes', value)
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: !this.orderMode,
        ghostClass: "ghost"
      };
    }
  },
  methods: {
    setNotesDebounce:_.debounce(function(){
      this.setNotes()
    }, 2000),
    setNotes () {
      this.$store.dispatch('notepadModule/setNotes', this.notes)
    },
    addNote () {
      this.$store.dispatch('notepadModule/addNote', this.scenarioData).then(() => {
        this.$refs.note.slice(-1)[0].focus()
      })
    },
    removeNote (ntoe) {
      this.$store.dispatch('notepadModule/removeNote', ntoe)
    }
  },
};
</script>

<style lang="scss" scoped>

  .notepad {
    display: grid;
    grid-template-areas: 
      ". title controls"
      ". ..... ........"
      ". notes notes"
      ". buttons ......";
    grid-template-columns: 25px 1fr 50px;
    grid-template-rows: 40px 62px auto 1fr;
    position: absolute;  
    z-index: 400;
    top: 0;
    left: 0;
    width: 40vw;
    min-width: 350px;
    padding: 22px 0 25px;


    transform: translateX(-100%);
    transition: all 0.25s cubic-bezier(0.4, 0.0, 0.2, 1);

    &.open {
      position: fixed;
      height: 100vh;
      transform: translateX(0);
      transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
      background-color: darken(#3d3dde, 20%);
    }

    @media all and (min-width: 768px) {
      // background-color: darken(#3d3dde, 20%);
      // position: fixed;
      height: 100vh;
    }
  }
  .controls {
    grid-area: controls;
    // text-align: center;
    justify-content: flex-start;
    display: flex;

    button {
      background: none;
      border: none;
      color: #fff;
      width: 20px;
      padding: 0;
    }
    .open-item {
      margin-left: 10px;
    }
  }

  .title {
    grid-area: title;
    color: #fff;
    align-self: center;
  }

  .notes {
    grid-area: notes;
    overflow: scroll;

    .handle {
      color: #fff;
      align-self: center;
      
      &:hover {
        cursor: move;
      }
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        margin-bottom: 2em;

        & > div {
          flex: 1;
        }

        button {
          min-width: 50px;
          color: #fff;

          &:hover {
            color: red;
          }
        }
      }
    }

    input[type="text"] {
      width: 100%;
      background-color: transparent;
      border: 0;
      border-bottom: 2px solid #fff;
      margin-bottom: 0.5em;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      
      &:focus {
        outline: none;
        border-bottom-color: #e1651d;
      }
    }

    textarea {
      resize: vertical;
      background-color: rgba(#fff, 0.25);
      color: #fff;
      border: 1px solid transparent;
      font-size: 15px;
      font-family: 'Kalam', cursive;

      &:focus {
        outline: none;
        border-color: #e1651d;
      }
    }

    textarea::selection,
    input[type="text"]::selection {
      background-color: #e1651d;
    }
  }
  .buttons {
    grid-area: buttons;
    display: flex;
    justify-content: flex-end;

    button {
      margin-left: 15px;
    }
  }
  .add-button {
    display: inline-flex;
    // justify-self: flex-end;
  }

  hr {
    height: 0;
    border: 0;
    border-top: 2px solid #7474CA;
    flex: 1;
  }
</style>